module.exports = __webpack_public_path__ + "img/bg_icon_02.45cd8410.svg";